import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    fill: theme.palette.common.white,
  },
}));

export default useStyles;
